<!--
  班主任手册-学期工作计划
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <search :ColNumber="2" :SearchList="SearchList" ref="SearchList" @onSearch="onSearch" v-if="SearchList!=null">
    </search>


    <el-card class="box-card" v-if="item==null || item.length==0">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont" style="padding-left: 0px;">
          学期工作计划
        </h3>
        <div class="card-tools">
          <ul class="nav">
            <li class="nav-item">
              <el-button v-if="isPower.adviserworkplan_create"
                type="success" icon="el-icon-circle-plus-outline" @click="onAdd()">新增</el-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-body">
        <el-empty :image-size="200" description="暂无数据" name="3"></el-empty>
      </div>
    </el-card>
    <el-card class="box-card" v-for="(p,index) in item" :key="index">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont" style="padding-left: 0px;">
          学期工作计划
        </h3>
        <div class="card-tools">
          <ul class="nav">
            <li class="nav-item">
              <el-button v-if="isPower.adviserworkplan_edit == true && isCurrentTeacher == true"
                size="mini" type="warning" icon="el-icon-circle-plus-outline" @click="onEdit(p.planId)">编辑</el-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-body DetailsFonts" style="padding-bottom: 0px;">
        <div v-html="p.content"></div>
      </div>
    </el-card>

  </div>
</template>

<script>
  import '@/assets/css/Admin.css';
  import search from '@/components/search.vue';

  export default {
    name: '',
    components: {
      search
    },
    data() {
      return {
        fullscreenLoading: false,
        page: null, //分页查询接口返回的结果
        item: [], //列表数据
        pageBtnList: null, //分页左侧按钮集合
        paging: { //分页数据
          pageLength: 0, // 总共页数
          Size: 10, // 当前请求数量
          Index: 1 //当前在第几页
        },
        SearchList: null, //搜索集合
        isPower: {
          //增删改查 权限管理
          adviserworkplan_create: false,
          adviserworkplan_edit: false,
          adviserworkplan_user: false,
        },
        isTeacher: false, //是否为班主任
        isCurrentTeacher: true, //历史班主任是否为当前用户
        ManagerClass: [], //班主任管理的班级的集合

        TeacherInfo:{},
      };
    },
    created() {
      let that = this;
      that.TeacherInfo=onGetNowUser(that);
      isPower(that, "adviserworkplan_create", "adviserworkplan_create");
      isPower(that, "adviserworkplan_edit", "adviserworkplan_edit");
      isPower(that, "adviserworkplan_user", "adviserworkplan_user");
      pagingPage(that);
    },
    methods: {
      onEdit(Id) {
        let that = this;
        that.$router.push({
          path: "/Admin/Adviser/WorkPlan/Edit/" + Id,
          query: {
            url: that.$router.history.current.fullPath
          }
        });
      },
      onAdd() {
        let that = this;
        that.$router.push({
          path: '/Admin/Adviser/WorkPlan/Create',
          query: {
            url: that.$router.history.current.fullPath
          }
        });
      },
      onSearch(params) {
        let that = this;
        let data = {};
        let searchData = params;
        searchData.forEach(element => {
          if (element.data) {
            data[element.zhi] = Join(element.data);
          }
        });
        data.PageNumer = 1;
        routerPath(that, "/Admin/Adviser/WorkPlan/Index", data, null, "PageSize");
      },
      pageBtnClick(index) {
        //分页组件左侧的按钮事件，按顺序进行判断
      },
      pagingClick(type, val) {
        let that = this;
        let url = "/Admin/Adviser/WorkPlan/Index";
        if (type == 1) { //更改每页条数触发的事件
          routerPath(
            that,
            url,
            "PageSize",
            val,
            "PageNumer",
            "SemesterId",
            "ClassId",
            "PlanType"
          );
        } else { //更改当前页时触发的事件
          routerPath(
            that,
            url,
            "PageNumer",
            val,
            "PageSize",
            "SemesterId",
            "ClassId",
            "PlanType"
          );
        }
      },
    },
    watch: {
      $route() {
        let that = this;
        pagingPage(that);
      }
    }
  };

  function pagingPage(that) {
    paging(
      that,
      function(r) {
        that.fullscreenLoading = true;
        ajaxGet(that, "/api/admin/Semester", null, function(semester) {
          ajaxGet(that, "/api/admin/adviserworkplan/type", null, function(resultType) {
            if (!regNullArray(semester)){

              let resultClass = that.TeacherInfo.isTeacher ? that.TeacherInfo.manageClass : that.TeacherInfo.allClass;

              var SemesterId = r.SemesterId;
              var semesters = [];
              for (var i in semester) {
                var it = {
                  Title: semester[i].name,
                  Value: semester[i].semesterId,
                };
                if (regNull(SemesterId)) {
                  if (semester[i].isCurrent == true) {
                    SemesterId = semester[i].semesterId;
                  }
                }
                semesters.push(it);
              }

              var ClassId = r.ClassId;
              var classList = [];


              for (var i in resultClass) {
                classList.push( {
                  Title: resultClass[i].alias,
                  Value: resultClass[i].classId,
                });
              }

              if (regNull(ClassId) && !regNullArray(resultClass)) {
                ClassId = resultClass[0].classId;
              }

              let Myurl =that.TeacherInfo.isTeacher? "/api/admin/adviserworkplan/search": "/api/admin/adviserworkplan/user/search";

              var PlanType = r.PlanType;
              var typeList = [];
              for (var i in resultType) {
                var it = {
                  Title: resultType[i].Text,
                  Value: resultType[i].Value,
                };
                if (PlanType == null || typeof(PlanType) == "undefined" || PlanType == "") {
                  PlanType = resultType[0].Value;
                }
                typeList.push(it);
              }

              that.SearchList = [{
                  type: "select",
                  Name: "学期",
                  data: SemesterId,
                  select: semesters, //选择的数据
                  zhi: "SemesterId",
                  isClear: false, //select是否可以清除
                  resetData: semesters[0].Value,
                },
                {
                  type: "select",
                  Name: "班级",
                  data: ClassId,
                  select: classList,
                  zhi: "ClassId",
                  isClear: false, //select是否可以清除
                  resetData:  resultClass[0].classId,
                },
              ];

              let data = {
                PageNumer: r.PageNumer,
                PageSize: r.PageSize,
                SemesterId: SemesterId,
                ClassId: ClassId,
                PlanType: PlanType,
              };
              that.isCurrentTeacher = true;
              ajaxGet(that, Myurl, data, function(r1) {
                that.page = r1;
                that.item = r1;

                var name = JSON.parse(that.$GetKey("Name"));
                that.isCurrentTeacher = true;
                if (that.item != '') {
                  if (that.item[0].adviser != name) {
                    that.isCurrentTeacher = false;
                  }
                }
                that.fullscreenLoading = false;
              });

            }else{
              that.fullscreenLoading = false;
            }
          });
        });
      },
      "SemesterId",
      "ClassId",
      "PlanType"
    );
  }
</script>

<style scoped="scoped">
  .divBtnCont{
    text-align: right;
    padding-bottom: 0.9375rem;/*15px*/
  }
</style>
